import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../../assets/utils/colors";
import { OutboundOutlined } from "@mui/icons-material";
import moment from "moment";

const AnnouncementWidget = ({ announcement }) => {
    return (
        <>
            <Link to={`/announcements/${announcement.id}`}>
                <Box
                    sx={{
                        width: '100%',
                        position: "relative",
                        ":before": {
                            content: "''",
                            width: "5%",
                            height: 3,
                            background: colors.primary,
                            position: "absolute",
                            top: 0,
                        },
                        ":after": {
                            content: "''",
                            width: "92%",
                            height: 3,
                            background: colors.bgColor2,
                            position: "absolute",
                            top: 0,
                            right: 0,
                        },
                        background: `linear-gradient(360deg, ${colors.bgColor1}, ${colors.bgColor4})`,
                        transition: `.3s`,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: `1px solid ${colors.bgColor2}`,
                        ":hover": {
                            transition: `.3s`,
                            boxShadow: `4px 4px 10px 0 ${colors.bgColor2}`,
                        },
                    }}
                >
                    <Box sx={{ position: "absolute", bottom: 5, right: 5 }}>
                        <Tooltip title="read more" arrow>
                            <IconButton
                                color="info"
                                sx={{
                                    ".icon": {
                                        transition: `.3s`,
                                    },
                                    ":hover": {
                                        ".icon": {
                                            transition: `.3s`,
                                            transform: `rotate(45deg)`,
                                        },
                                    },
                                }}
                            >
                                <OutboundOutlined className="icon" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Grid container>
                        <Grid item sm={2} xs={3}>
                            <Box
                                sx={{
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    ".icon": {
                                        fontSize: 45,
                                    },
                                    color: colors.secondary,
                                }}
                            >
                                <Box>
                                    <Typography
                                        sx={{
                                            fontSize: 45,
                                            textAlign: "center",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {moment(announcement.created_at).format(
                                            "d"
                                        )}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            color: colors.primary,
                                        }}
                                        noWrap
                                    >
                                        {moment(announcement.created_at).format(
                                            "MMM YYYY"
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={10} xs={9}>
                            <Box sx={{ p: 3 }}>
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: "bold",
                                        mb: 1,
                                        opacity: 0.9,
                                        color: colors.primary,
                                    }}
                                >
                                    {announcement.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: 12,
                                        color: "gray",
                                    }}
                                >
                                    {announcement.description}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Link>
        </>
    );
};

export default AnnouncementWidget;
